import script from "./HistoricalProjectSavingStepsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoricalProjectSavingStepsModal.vue?vue&type=script&setup=true&lang=ts"

import "./HistoricalProjectSavingStepsModal.vue?vue&type=style&index=0&id=2282e5e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2282e5e4"]])

export default __exports__